import { useSelector, useDispatch } from "react-redux";

import {
  setShowInsuranceModal,
  setSelectedInsurance,
} from "app/store/insurance/slice/insuranceSlice";

const useInsuranceModal = () => {
  const { showInsuranceModal, isUpdateOperation, selectedInsurance } =
    useSelector((state) => state.insurance);
  const dispatch = useDispatch();

  const handleModalClose = () => {
    dispatch(setShowInsuranceModal(false));
    selectedInsurance && dispatch(setSelectedInsurance(null));
  };

  return { showInsuranceModal, isUpdateOperation, handleModalClose };
};

export default useInsuranceModal;
